export const USER_OWNERSHIP = 'user_ownership'
export const USER_INDIRECT_OWNERSHIP = 'user_indirect_ownership'
export const USER_INDIRECT_ROLE = 'user_indirect_role'
export const RELATION_OWNERSHIP = 'relation_ownership'
export const RELATION_INDIRECT_OWNERSHIP = 'relation_indirect_ownership'
export const RELATION_INDIRECT_ROLE = 'relation_indirect_role'